import axios from 'axios'
// import {baseUrl} from './url'
const url = process.env.VUE_APP_Server // 根据启动环境服务器地址赋值给url
console.log(url)
const instance = axios.create({
  baseURL: url
})

// 所有的请求都会被下面拦截
instance.interceptors.request.use(
  config => {
    // debugger
    // 用户登录以后判断是否需要添加token
    let userInfo = localStorage.getItem('userInfo')
    if (userInfo) { // 判断是否存在token，如果存在的话，则每个http header都加上token
      userInfo = JSON.parse(userInfo)
      if (userInfo) {
        config.headers.token = userInfo // 请求头加上token
      }
    }
    const num = 100 + Math.ceil(Math.random() * 100000)
    const time = new Date().getTime() + '' + num
    config.headers.requestId = time
    config.headers.s_p = 0
    return config
  }
)
// http response 拦截器
instance.interceptors.response.use(
  response => {
    return response
  },
  // 接口错误状态处理，也就是说无响应时的处理
  error => {
    return error
  }
)

export default instance
